export const TITLE_ON_TRUNCATE_CLASSNAME = 'rds-handled-titleOnTruncate';
